import { IBaseRequestDto, IBaseResponseDto } from './BaseDto'
import { IBuffetDishDto } from './BuffetDishDto'
import { ITag } from './TagsDto'
import { DimensionType } from './BuffetReportDto'
import { IRole, Role } from './UserDto'

export enum PlanMenuStatusType {
  Opened = 'OPENED',
  Closed = 'CLOSED',
  Change = 'REPLACEMENT_DISH',
}
type EventType = 'status' | 'replacement'
interface INonSyncedDishes {
  id: number
  name: string
}

export interface IStatusHistory {
  id: number
  user: {
    id: number
    username: string
    email: string
    userRole: IRole
  }
  order: number
  status: PlanMenuStatusType
  createdAt: string
  nonSyncedDishes: INonSyncedDishes[]
  orderPlanMenuIntegrationStatus: null
}

export interface IPlanMenuControlOrderBase {
  name: string
  sourceRepresent: string
  dateStart: string
  dateEnd: string
  planMenuStatus: PlanMenuStatusType
  planMenu: number
  dishTotalCount: number
  dishPlannedCount: number
  comment: string
}
export interface HistoryItem {
  id: number
  dimension?: number
  originalDish?: IBuffetDishDto
  newDish?: IBuffetDishDto
  user: {
    id: number
    username: string
    email: string
    userRole: IRole
  }
  createdAt: string
  status: PlanMenuStatusType
  comment?: string | null
  eventType?: EventType
  order?: number
  integrationComment?: string | null
  orderPlanMenuIntegrationStatus?: string | null
  nonSyncedDishes?: INonSyncedDishes[]
}
export interface IPlanMenuControlOrderDto extends IPlanMenuControlOrderBase {
  id: number
  lastStatusHistory: IStatusHistory
}

export interface IPlanMenuControlOrderLineDto {
  id: number
  lineGuid: string
  dish: IBuffetDishDto
  quantity: number
  deliveredStatus: boolean
  isPlanned: boolean
  lastDimensionTime: number | null
  implementationTime: number | null
  implementationTimeExceeded: number | null
  countExpiredDim: number
  countNotExpiredDim: number
  countDimWithComment: number
}

export interface IPlanMenuControlDimensionDto {
  id: number
  guid: string
  image: string
  imageOnS3: string
  thermoImage: string
  thermoImageOnS3: string
  temperature: number
  dimensionDatetime: string
  weightTotal: number
  dimensionType: DimensionType
  comment: string
  dishImplementationTime: number
  implementationTime: number
  implementationTimeExceeded: number
  weightOfMillet: number
  weightOfDish: number
  dishTempMin: number
  dishTempMax: number
  dishStandardWeight: number
  dishStandardImage: string
  dishStandardImageOnS3: string
  tempChecker: number
  // id: number
  // photoUrl: string
  // thermoPhotoUrl: string
  // dishStandardImage: string
  // dishStandardWeight: number
  // temperature: number | null
  // dimensionDatetime: string
  // weight: number | null
  // milletWeight: number
  // dishTempMin: number
  // dishTempMax: number
  // tempChecker: number
  // quantity: number
  // dimensionType: DimensionType
  // comment: string
  // dishImplementationTime: number | null
  // implementationTime: number
  // implementationTimeExceeded: number | null
  dimensionTags: ITag[]
}

export interface IOrderLinesOpenDto {
  id: number
  lineGuid: string
  dish: IBuffetDishDto
  quantity: number
  deliveredStatus: boolean
  isPlanned: boolean
  lastDimensionTime: number
  implementationTime: number
  implementationTimeExceeded: number
  imageOnS3: string
  image?: string
  countDimensions?: number
  countDimensionsWithDefaultMillet?: number
}

export interface IPlanMenuControlOrdersDto extends IBaseResponseDto {
  results: IPlanMenuControlOrderDto[]
}
export interface IPlanMenuControlOrdersLinesOpenDto extends IBaseResponseDto {
  results: IOrderLinesOpenDto[]
}

export interface IPlanMenuControlOrdersRequest extends IBaseRequestDto {
  search?: string
  tag_ids?: string
  dimension_datetime?: string
  dish_ids?: string
  category_ids?: string
  implemented_status?: string
  delivery_status?: string
  dimension_type?: string
  value_type_dimension?: string
  comment?: string
  order_date_execution_gte?: string
  order_date_execution_lte?: string
  start_time?: string
  end_time?: string
  order_ids?: string
}
